// extracted by css-extract-rspack-plugin
module.exports =  {"modal__add-table":"TableMaker-RZdg__modal__add-table"};